import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import api from '../lib/api'
import useNotify from '../hooks/useNotify'

const AddNewAccount = ({ show, setShow, formData, action, setFormData, setNotification, onSaved }) => {
    const [loader, setLoader] = useState(false);
    const notify = useNotify(setNotification);

    const isAdd = action === "add";
    const close = () => setShow(false);

    const submit = (e) => {
        e.preventDefault();
        setLoader(true);

        const request = isAdd
            ? api.post('/accounts', formData)
            : api.put(`/accounts/${formData.id}`, formData);

        request
            .then((res) => {
                notify.success(res.data.message.en);
                close();
                if (onSaved) onSaved();
            })
            .catch((err) => notify.error(err))
            .finally(() => setLoader(false));
    };

    return (
        <Modal show={show} onHide={close} size='lg' centered>
            {/* Title now reflects the mode; it always read "Add New Account",
                including when editing. */}
            <Modal.Header closeButton><h2 className="modal-title-text">{isAdd ? "Add New Account" : "Edit Account"}</h2></Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <form className='row' onSubmit={submit}>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-buyer">Buyer*</label>
                                <input id="form-buyer" required placeholder="Enter buyer number" type="text" className="form-control" name="buyer" value={formData.buyer ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, buyer: e.target.value }))} />
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-account-password">Password*</label>
                                <input id="form-account-password" required placeholder="Enter password" type="text" className="form-control" name="password" value={formData.password ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))} />
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-auction">Auction*</label>
                                <select id="form-auction" required className="form-control" name="auction" value={formData.auction ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, auction: e.target.value }))}>
                                    <option value="">Select Auction</option>
                                    <option value="copart">Copart</option>
                                    <option value="iaai">IAAI</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-6 mb-4">
                            <div className="form-group">
                                <label htmlFor="form-comment">Comment*</label>
                                <input id="form-comment" required placeholder="Enter comment" type="text" className="form-control" name="comment" value={formData.comment ?? ""} onChange={(e) => setFormData((prev) => ({ ...prev, comment: e.target.value }))} />
                            </div>
                        </div>
                        <div className="modal-action-buttons">
                            <button type="submit" disabled={loader} className="submit-modal-form-btn">{loader ? <div className="button-loader"></div> : (isAdd ? "Submit" : "Save")}</button>
                            <button type="button" onClick={close} className="cancel-modal-form-btn">Cancel</button>
                        </div>
                    </form>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddNewAccount
